import { z } from "zod";

// One half of a directory search on its own: `text` for names, `vector` for
// meaning. A search that names neither gets both, names first.
export const DirectorySearchModeSchema = z.enum(["text", "vector"]);

export type DirectorySearchMode = z.infer<typeof DirectorySearchModeSchema>;

export const DirectorySearchMode = DirectorySearchModeSchema.enum;
